"use strict";

import $ from 'jquery';

export function initInScope($scope) {
    let $share = $scope.find('.js-share'),
        $btn = $share.find('.js-share__btn'),
        $link = $share.find('.js-share__link');
    $btn.on('click', () =>{
        $link.select();
        $link[0].setSelectionRange(0, 99999);
        navigator.clipboard.writeText($link.val());

        $btn.find('.js-share-btn__text').addClass('d-none');
        $btn.find('.js-share-btn__text--active').removeClass('d-none');
    });
}
